import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { setChannel } from '../../creative/add/build/buildCreativeSlice'
import { useDispatch } from 'react-redux'
import { fetchCreatives } from './groupCreativeSlice'
import BuildCreative from '../../creative/add/build/BuildCreative'
import useDashboardReferrer from '../useDashboardReferrer'
import { useHistory, useParams } from 'react-router-dom'

const GroupCreativeAdd = ({ channel, onClickOtherTab }) => {
  const dispatch = useDispatch()
  const { accountId: adAccountId } = useParams()
  const referrer = useDashboardReferrer()
  const { campaignId, adGroupId } = useParams()
  const history = useHistory()

  useEffect(() => {
    if (channel) dispatch(setChannel(channel))
  }, [dispatch, channel])

  return (
    <BuildCreative
      afterSave={() => {
        dispatch(fetchCreatives(channel.id))
        history.push(
          `/${adAccountId}/ads/campaigns/${campaignId}/groups/${adGroupId}/creatives${
            referrer ? `?from=${referrer}` : ''
          }`
        )
      }}
      otherTabName="기존 소재 사용하기"
      onClickOtherTab={onClickOtherTab}
    />
  )
}
export default GroupCreativeAdd
GroupCreativeAdd.propTypes = {
  channel: PropTypes.object,
  onClickOtherTab: PropTypes.func,
}
